import { Autocomplete, Button, Checkbox, FormControl, FormControlLabel, Grid, TextField } from "@mui/material"
import styles from '../../Styles/ComponentStyles/ProfileStyle/Profile.module.scss'
import globalStyles from '../../Styles/ComponentStyles/global.module.scss'
import { useEffect, useState } from "react"

interface Agent {
    user_id: number;
    user_firstname: string;
    user_lastname: string;
}

interface AssignmentData {
    user_profile_id: number | null;
    send_email_flag: boolean;
    agent_id: number | null;
}

const AssignProfileToAgentPopup = ({ agentOptions, selectedProfileData, handleAssignToAgent, setFlagAssignAgentPopup }: any) => {
    const [selectedAgent, setSelectedAgent] = useState<Agent>(
        agentOptions.find((agent: any) => agent.user_id === selectedProfileData?.user_assigned_agent_id) || null
    )

    // Initialize all state in a single object
    const [assignmentData, setAssignmentData] = useState<AssignmentData>({
        user_profile_id: selectedProfileData?.user_profile_id || null,
        send_email_flag: false,
        agent_id: selectedProfileData?.user_assigned_agent_id || null
    });
    const [flagAssignedAgentChanged, setFlagAssignedAgentChanged] = useState(false)

    // Unified change handler
    const handleChange = (
        type: 'agent' | 'email',
        value: any
    ) => {
        if (value?.user_id != selectedAgent?.user_id) {
            setFlagAssignedAgentChanged(false)
        }
        setAssignmentData(prev => {
            switch (type) {
                case 'agent':
                    setSelectedAgent(value);
                    return {
                        ...prev,
                        agent_id: value?.user_id || null
                    };
                case 'email':
                    return {
                        ...prev,
                        send_email_flag: value
                    };
                default:
                    return prev;
            }
        });
    };

    // Wrapper for handleAssignToAgent
    const handleSubmit = () => {
        handleAssignToAgent(assignmentData);
    };

    useEffect(() => {
        if (selectedProfileData?.user_assigned_agent_id == selectedAgent?.user_id) {
            setFlagAssignedAgentChanged(true)
        }
    }, [])

    return (
        <Grid container>
            <Grid item xs={12} sx={{ padding: "20px 10px" }}>
                <Grid container>
                    <Grid item xs={12}>
                        <Grid container gap={"5px"}>
                            <Grid item xs={12}>
                                <Grid container gap={"5px"}>
                                    <Grid item xs={12} className={globalStyles.globalPFTextfieldLabel}>
                                        Agent
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth sx={{ height: '100%' }}>
                                            <Autocomplete
                                                filterOptions={(options, state) =>
                                                    options.filter((option) => {
                                                        const label = `${option.user_firstname || ''} ${option.user_lastname || ''}`.toLowerCase();
                                                        return label.includes(state.inputValue.toLowerCase());
                                                    })
                                                }
                                                fullWidth
                                                className={globalStyles.globalAutoCompleteStyle}
                                                disableClearable
                                                id="agent-selector"
                                                onChange={(_, newValue) => { handleChange('agent', newValue) }}
                                                value={selectedAgent}
                                                getOptionLabel={(option: Agent) =>
                                                    option ? `${option.user_firstname || ''} ${option.user_lastname || ''}`.trim() : ''
                                                }
                                                isOptionEqualToValue={(option, value) =>
                                                    option.user_id === value?.user_id
                                                }
                                                options={agentOptions || []}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        size="small"
                                                        variant="outlined"
                                                        placeholder="Select Agent"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            sx: {
                                                                backgroundColor: 'white',
                                                                '&.Mui-focused': {
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: "1px solid #E2E8F0", // Remove blue focus border
                                                                    },
                                                                },
                                                                '&:hover': {
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: "1px solid #E2E8F0", // Remove black hover border
                                                                    },
                                                                },
                                                            }
                                                        }}
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '&.Mui-focused fieldset': {
                                                                    border: "1px solid #E2E8F0", // Remove blue focus border
                                                                },
                                                            },
                                                        }}
                                                    />
                                                }
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '130px',
                                                        backgroundColor: 'white'
                                                    }
                                                }}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        backgroundColor: 'white',
                                                        '&.Mui-focused': {
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                border: "1px solid #E2E8F0 !important", // Remove blue focus border
                                                            },
                                                        },
                                                    },
                                                    "& .MuiAutocomplete-listbox": {
                                                        backgroundColor: 'white',
                                                        maxHeight: "130px !important",
                                                        overflowY: "auto"
                                                    }
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={assignmentData.send_email_flag}
                                            onChange={(event) => handleChange('email', event.target.checked)}
                                            sx={{
                                                color: "#3B78CE"

                                            }}
                                        />
                                    }
                                    label="Send email to Agent"
                                    sx={{
                                        "& .MuiFormControlLabel-label": {
                                            fontSize: "15px",
                                            fontWeight: "400",
                                            color: "#000000",

                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ margin: "40px 0px 0px" }}>
                        <Grid container sx={{ justifyContent: 'center', gap: '20px' }} alignItems={"center"}>
                            <Grid item>
                                <Button
                                    sx={{
                                        width: "100px",
                                        height: "36px",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        backgroundColor: "#fff !important",
                                        textTransform: "none",
                                        color: "#3B78CE",
                                        border: "1px solid #3B78CE",
                                    }}
                                    onClick={() => setFlagAssignAgentPopup(false)}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    sx={{
                                        width: "100px",
                                        height: "40px",
                                        color: "white",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        textTransform: "none",
                                        backgroundColor: "#3B78CE !important",
                                    }}
                                    onClick={handleSubmit}
                                    disabled={flagAssignedAgentChanged}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default AssignProfileToAgentPopup;